(function () {
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href === '#') return;
        var target = document.querySelector(href);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initPdpGallery() {
    document.querySelectorAll('[data-gp-pdp-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        var gallery = button.closest('[data-gp-pdp-gallery]');
        if (!gallery) return;
        var image = gallery.querySelector('img[id^="GpPdpMainImage-"]');
        var src = button.getAttribute('data-src');
        var alt = button.getAttribute('data-alt') || '';
        if (image && src) {
          image.src = src;
          image.alt = alt;
          gallery.querySelectorAll('[data-gp-pdp-thumb]').forEach(function (thumb) { thumb.classList.remove('is-active'); });
          button.classList.add('is-active');
        }
      });
    });

    document.querySelectorAll('[data-gp-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        var wrapper = button.closest('.gp-product-gallery');
        if (!wrapper) return;
        var image = wrapper.querySelector('.gp-product-gallery__main-image');
        var full = button.getAttribute('data-full');
        var alt = button.getAttribute('data-alt') || '';
        if (image && full && image.tagName === 'IMG') {
          image.src = full;
          image.alt = alt;
          wrapper.querySelectorAll('[data-gp-thumb]').forEach(function (thumb) { thumb.classList.remove('is-active'); });
          button.classList.add('is-active');
        }
      });
    });
  }

  function initVariantSelects() {
    document.querySelectorAll('select[data-gp-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var container = select.closest('.gp-pdp') || select.closest('.gp-product-redesign') || document;
        var price = option.getAttribute('data-price');
        var compare = option.getAttribute('data-compare');
        var available = option.getAttribute('data-available') !== 'false';
        var priceEl = container.querySelector('[data-gp-price]');
        var compareEl = container.querySelector('[data-gp-compare]');
        var submit = container.querySelector('[data-gp-submit]');
        var mobileSticky = container.querySelector('[data-gp-mobile-sticky]');

        if (priceEl && price) priceEl.textContent = price;
        if (compareEl) {
          if (compare) {
            compareEl.textContent = compare;
            compareEl.style.display = '';
          } else {
            compareEl.textContent = '';
            compareEl.style.display = 'none';
          }
        }
        if (submit) submit.disabled = !available;
        if (mobileSticky) {
          var stickyPrice = mobileSticky.querySelector('span');
          if (stickyPrice && price) stickyPrice.textContent = price;
          var stickyButton = mobileSticky.querySelector('[data-gp-sticky-submit]');
          if (stickyButton) stickyButton.disabled = !available;
        }
        if (window.history && window.history.replaceState) {
          var base = window.location.pathname;
          window.history.replaceState({}, '', base + '?variant=' + option.value);
        }
      });
    });
  }

  function initPdpStickySubmit() {
    document.querySelectorAll('[data-gp-sticky-submit]').forEach(function (button) {
      button.addEventListener('click', function () {
        var pdp = button.closest('.gp-pdp') || document;
        var form = pdp.querySelector('.gp-js-product-form');
        if (!form) return;
        var submit = form.querySelector('[data-gp-submit]');
        if (submit) submit.click();
        else form.submit();
      });
    });

    var stickyBars = document.querySelectorAll('[data-gp-mobile-sticky]');
    if (!stickyBars.length) return;
    var onScroll = function () {
      stickyBars.forEach(function (bar) {
        var pdp = bar.closest('.gp-pdp') || document;
        var form = pdp.querySelector('.gp-js-product-form');
        var threshold = form ? form.getBoundingClientRect().bottom + window.scrollY : 520;
        if (window.scrollY > threshold) bar.classList.add('is-visible');
        else bar.classList.remove('is-visible');
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }


  function initShareButtons() {
    document.querySelectorAll('[data-gp-share-url]').forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-gp-share-url') || window.location.href;
        var message = document.querySelector('[data-gp-share-message]');
        var label = button.textContent;
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            if (message) message.textContent = 'Link copied — send it before this piece is claimed.';
            button.textContent = 'Link copied';
            window.setTimeout(function () { button.textContent = label; }, 2200);
          }).catch(function () {
            if (message) message.textContent = url;
          });
        } else if (message) {
          message.textContent = url;
        }
      });
    });
  }

  function initRecentlyViewed() {
    var storageKey = 'gp_recently_viewed_products';
    var maxStored = 8;
    var productNode = document.querySelector('[data-gp-current-product]');

    function readItems() {
      try {
        var parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    function writeItems(items) {
      try { window.localStorage.setItem(storageKey, JSON.stringify(items.slice(0, maxStored))); } catch (e) {}
    }

    if (productNode) {
      try {
        var productData = JSON.parse(productNode.textContent || '{}');
        if (productData && productData.id && productData.url) {
          var items = readItems().filter(function (item) { return String(item.id) !== String(productData.id); });
          items.unshift(productData);
          writeItems(items);
        }
      } catch (e) {}
    }

    document.querySelectorAll('[data-gp-recently-viewed]').forEach(function (section) {
      var grid = section.querySelector('[data-gp-recently-viewed-grid]');
      if (!grid) return;
      var currentId = section.getAttribute('data-current-product-id');
      var limit = parseInt(grid.getAttribute('data-limit') || '4', 10);
      var items = readItems().filter(function (item) {
        return item && item.id && item.url && String(item.id) !== String(currentId || '');
      }).slice(0, limit);

      if (!items.length) {
        section.setAttribute('hidden', 'hidden');
        return;
      }

      grid.innerHTML = items.map(function (item) {
        var title = String(item.title || 'Glass pendant').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        var price = String(item.price || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        var image = item.image ? '<img src="' + item.image + '" alt="' + title + '" loading="lazy">' : '<div class="gp-placeholder">Product image</div>';
        return '<a class="gp-recent-card" href="' + item.url + '">' + image + '<div class="gp-recent-card__body"><h3 class="gp-recent-card__title">' + title + '</h3>' + (price ? '<div class="gp-recent-card__price">' + price + '</div>' : '') + '</div></a>';
      }).join('');
      section.removeAttribute('hidden');
    });
  }


  document.addEventListener('DOMContentLoaded', function () {
    initSmoothScroll();
    initPdpGallery();
    initVariantSelects();
    initPdpStickySubmit();
    initShareButtons();
    initRecentlyViewed();
  });
})();
